import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import Protected from './protected';

/**
 * ProtectedRoute wraps react-router Route + permission + optional business gate.
 */
const ProtectedRoute = ({
    component: Comp,
    resource,
    action,
    fallback,
    permissionFallback,
    gateFallback,
    passThrough,
    ...rest
}) => {
    return (
        <Route
            {...rest}
            render={(rp) => {
                return (
                    <Protected
                        resource={resource}
                        action={action}
                        {...rest}
                    >
                        {fallback && <Protected.Fallback>{fallback}</Protected.Fallback>}
                        {permissionFallback && <Protected.PermissionFallback>{permissionFallback}</Protected.PermissionFallback>}
                        {gateFallback && <Protected.GateFallback>{gateFallback}</Protected.GateFallback>}
                        <Comp {...rp} {...passThrough} />
                    </Protected>
                );
            }}
        />
    );
};

ProtectedRoute.propTypes = {
    // React Router path-related props are passed through (path, exact, etc.)
    component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired, // could be class or function component
    resource: PropTypes.string.isRequired,
    resourceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    action: PropTypes.string,
    gate: PropTypes.bool,
    showNotFound: PropTypes.bool,
    context: PropTypes.object,
    fallback: PropTypes.node,
    permissionFallback: PropTypes.node,
    gateFallback: PropTypes.node,
    passThrough: PropTypes.object,
};

ProtectedRoute.defaultProps = {
    action: 'read',
    showNotFound: true,
    passThrough: {},
    fallback: null,
    permissionFallback: null,
    gateFallback: null,
    context: null,
};

export default ProtectedRoute;